<template>
  <div v-if="mainStore.inscription_as_admin">
    <v-divider></v-divider>
    <h4>Modalités de paiement</h4>
    <v-row class="mt-3">
      <v-col>
        <label class="field_label">Montant payé</label>
        <p>Vous pouvez indiquer ci-dessus le prix que vous avez fait payé réellement au participant/groupe. La remise
          effectuée sera automatiquement calculée.</p>
        <v-text-field type="number" v-model="paiement_admin.prix_apres_remise" ref="field"
          :disabled="paiement_admin.moyen_de_paiement == 'Invité'"></v-text-field>
      </v-col>
      <v-col>
        <label class="field_label">Moyen de paiement</label>
        <v-select :items="type_paiement_admin" v-model="paiement_admin.moyen_de_paiement"
          ref="field"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-subtitle-1">Vous pouvez indiquer ci-dessus le prix que vous avez fait payé réellement au
          participant/groupe. La remise effectuée sera automatiquement calculée.</div>
        <div class="text-body">
          Le total de la commande théorique est de : <b>{{ paiement_admin.prix_base }}€</b>
        </div>
        <div class="text-body">
          La remise appliquée est de : <b>{{ paiement_admin.remise }}€</b>
        </div>
        <div class="text-body">
          Le total payé est de : <b>{{ paiement_admin.prix_apres_remise }}€</b>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn :loading="loadingPost" color="primary-dark" class="mt-4" variant="tonal" size="default"
          @click="postCommande"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Valider cette commande</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import Paiement_Admin from "@/classes/Paiement_Admin/Paiement_Admin.class.js";
export default {
  data() {
    return {
      type_paiement_admin: [
        { title: "Chèque", value: "Chèque" },
        { title: "Virement", value: "Virement" },
        { title: "Espèces", value: "Espèces" },
        { title: "Invité - Gratuit", value: "Invité" },
      ],
      paiement_admin: new Paiement_Admin(),
      loadingPost: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  watch: {
    "paiement_admin.moyen_de_paiement": function () {
      if (this.paiement_admin.moyen_de_paiement == "Invité") {
        this.paiement_admin.prix_apres_remise = 0;
      } else {
        this.paiement_admin.prix_apres_remise = this.paiement_admin.prix_base;
      }
    },
    "paiement_admin.prix_apres_remise": function () {
      if (this.paiement_admin.prix_apres_remise == "") {
        this.paiement_admin.remise = this.paiement_admin.prix_base;
        this.paiement_admin.prix_apres_remise = 0;
      }
      this.paiement_admin.remise = parseFloat(this.paiement_admin.prix_base) - parseFloat(this.paiement_admin.prix_apres_remise);
      this.bookingStore.paiement_admin = this.paiement_admin;
    },
  },
  methods: {
    postCommande() {
      this.loadingPost = true;
      this.$emit("onPostAdmin", this.paiement_admin);
    },
  },
  created() {
    if (this.mainStore.inscription_as_admin) {
      this.bookingStore.prix_total = this.bookingStore.prix;
      this.bookingStore.exlude_taxe = 1;
      this.bookingStore.taxe = 0;
      this.paiement_admin.prix_base = this.bookingStore.prix;
      this.paiement_admin.prix_apres_remise = this.bookingStore.prix;
      this.bookingStore.paiement_admin = this.paiement_admin;
    }
  },
};
</script>

<style lang="scss" scoped></style>